// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.navbar {
	position: fixed;
	top: 0;
	left: 0;
	width: 100%;
	display: flex;
	justify-content: space-between;
	align-items: center;
	height: 100px;
	padding: 15px;
	background-color: var(--primary-color);
	color: var(--white);
	border-bottom: 5px solid var(--secondary-color);
	z-index: 999;
}

.navbar-wrapper {
	display: flex;
	justify-content: center;
	align-items: center;
}

.navbar-list {
	display: flex;
	align-items: center;
	list-style: none;
}

.navbar-wrapper:first-child .navbar-list:last-child {
	margin-right: 20px;
}

.profile-navbar-container {
	display: flex;
	align-items: center;
	justify-content: center;
	cursor: pointer;
	position: relative;
}

.menu-bar {
	position: absolute;
	top: 85px;
	right: -15px;
	width: 200px;
	box-shadow: 0px 4px 6px rgba(0, 0, 0, 0.1);
	z-index: 1000;
}

.menu-bar ul {
	border: 2px solid rgb(219, 213, 213);
	border-radius: 5px;
	list-style: none;
}

.menu-bar li {
	padding: 10px;
	font-size: 18px;
	background-color: rgb(246, 243, 243);
	transition: all 0.2s;
	color: black;
}

.menu-bar li:last-child {
	color: rgb(255, 52, 82);
}

.menu-bar li:hover {
	background-color: rgb(243, 236, 236);
}

.profile-border {
	border: none;
	border-radius: 50%;
	width: 65px;
	height: 65px;
	display: inline-block;
	overflow: hidden;
	background-color: inherit;
}

.profile-image {
	width: 100%;
	height: 100%;
	object-fit: cover;
	border-radius: 50%;
	background-color: var(--secondary-color);
}

.navbar-title {
	font-size: 1.6rem;
	font-weight: 600;
	color: var(--white);
	margin: 0;
	text-align: right;
}

.back-button {
	width: 100px;
	background-color: var(--secondary-color);
	color: black;
	font-size: 18px;
}

.back-button:hover {
	background-color: var(--secondary-hover);
}

.home-button {
	background-color: var(--secondary-color);
	color: black;
	font-size: 18px;
	padding: 8px 16px;
	text-decoration: none;
	border-radius: 5px;
	margin-right: 20px;
	white-space: nowrap;
}

.home-button:hover {
	background-color: var(--secondary-hover);
}

.modal-overlay {
    top: 120px;
}

@media (max-width: 768px) {
	.profile-border {
		width: 60px;
		height: 60px;
	}

	.menu-bar {
		top: 82px;
		width: 120px;
	}

	.menu-bar li {
		font-size: 12px;
	}

	.navbar-title {
		font-size: 23px;
		text-align: center;
	}
}

@media (max-width: 480px) {
	.profile-border {
		width: 55px;
		height: 55px;
	}

	.menu-bar {
		top: 80px;
		width: 80px;
	}

	.menu-bar li {
		font-size: 10px;
	}

	.navbar-title {
		font-size: 20px;
		text-align: center;
	}
}
`, "",{"version":3,"sources":["webpack://./src/components/Navbar/Navbar.css"],"names":[],"mappings":"AAAA;CACC,eAAe;CACf,MAAM;CACN,OAAO;CACP,WAAW;CACX,aAAa;CACb,8BAA8B;CAC9B,mBAAmB;CACnB,aAAa;CACb,aAAa;CACb,sCAAsC;CACtC,mBAAmB;CACnB,+CAA+C;CAC/C,YAAY;AACb;;AAEA;CACC,aAAa;CACb,uBAAuB;CACvB,mBAAmB;AACpB;;AAEA;CACC,aAAa;CACb,mBAAmB;CACnB,gBAAgB;AACjB;;AAEA;CACC,kBAAkB;AACnB;;AAEA;CACC,aAAa;CACb,mBAAmB;CACnB,uBAAuB;CACvB,eAAe;CACf,kBAAkB;AACnB;;AAEA;CACC,kBAAkB;CAClB,SAAS;CACT,YAAY;CACZ,YAAY;CACZ,0CAA0C;CAC1C,aAAa;AACd;;AAEA;CACC,oCAAoC;CACpC,kBAAkB;CAClB,gBAAgB;AACjB;;AAEA;CACC,aAAa;CACb,eAAe;CACf,oCAAoC;CACpC,oBAAoB;CACpB,YAAY;AACb;;AAEA;CACC,uBAAuB;AACxB;;AAEA;CACC,oCAAoC;AACrC;;AAEA;CACC,YAAY;CACZ,kBAAkB;CAClB,WAAW;CACX,YAAY;CACZ,qBAAqB;CACrB,gBAAgB;CAChB,yBAAyB;AAC1B;;AAEA;CACC,WAAW;CACX,YAAY;CACZ,iBAAiB;CACjB,kBAAkB;CAClB,wCAAwC;AACzC;;AAEA;CACC,iBAAiB;CACjB,gBAAgB;CAChB,mBAAmB;CACnB,SAAS;CACT,iBAAiB;AAClB;;AAEA;CACC,YAAY;CACZ,wCAAwC;CACxC,YAAY;CACZ,eAAe;AAChB;;AAEA;CACC,wCAAwC;AACzC;;AAEA;CACC,wCAAwC;CACxC,YAAY;CACZ,eAAe;CACf,iBAAiB;CACjB,qBAAqB;CACrB,kBAAkB;CAClB,kBAAkB;CAClB,mBAAmB;AACpB;;AAEA;CACC,wCAAwC;AACzC;;AAEA;IACI,UAAU;AACd;;AAEA;CACC;EACC,WAAW;EACX,YAAY;CACb;;CAEA;EACC,SAAS;EACT,YAAY;CACb;;CAEA;EACC,eAAe;CAChB;;CAEA;EACC,eAAe;EACf,kBAAkB;CACnB;AACD;;AAEA;CACC;EACC,WAAW;EACX,YAAY;CACb;;CAEA;EACC,SAAS;EACT,WAAW;CACZ;;CAEA;EACC,eAAe;CAChB;;CAEA;EACC,eAAe;EACf,kBAAkB;CACnB;AACD","sourcesContent":[".navbar {\n\tposition: fixed;\n\ttop: 0;\n\tleft: 0;\n\twidth: 100%;\n\tdisplay: flex;\n\tjustify-content: space-between;\n\talign-items: center;\n\theight: 100px;\n\tpadding: 15px;\n\tbackground-color: var(--primary-color);\n\tcolor: var(--white);\n\tborder-bottom: 5px solid var(--secondary-color);\n\tz-index: 999;\n}\n\n.navbar-wrapper {\n\tdisplay: flex;\n\tjustify-content: center;\n\talign-items: center;\n}\n\n.navbar-list {\n\tdisplay: flex;\n\talign-items: center;\n\tlist-style: none;\n}\n\n.navbar-wrapper:first-child .navbar-list:last-child {\n\tmargin-right: 20px;\n}\n\n.profile-navbar-container {\n\tdisplay: flex;\n\talign-items: center;\n\tjustify-content: center;\n\tcursor: pointer;\n\tposition: relative;\n}\n\n.menu-bar {\n\tposition: absolute;\n\ttop: 85px;\n\tright: -15px;\n\twidth: 200px;\n\tbox-shadow: 0px 4px 6px rgba(0, 0, 0, 0.1);\n\tz-index: 1000;\n}\n\n.menu-bar ul {\n\tborder: 2px solid rgb(219, 213, 213);\n\tborder-radius: 5px;\n\tlist-style: none;\n}\n\n.menu-bar li {\n\tpadding: 10px;\n\tfont-size: 18px;\n\tbackground-color: rgb(246, 243, 243);\n\ttransition: all 0.2s;\n\tcolor: black;\n}\n\n.menu-bar li:last-child {\n\tcolor: rgb(255, 52, 82);\n}\n\n.menu-bar li:hover {\n\tbackground-color: rgb(243, 236, 236);\n}\n\n.profile-border {\n\tborder: none;\n\tborder-radius: 50%;\n\twidth: 65px;\n\theight: 65px;\n\tdisplay: inline-block;\n\toverflow: hidden;\n\tbackground-color: inherit;\n}\n\n.profile-image {\n\twidth: 100%;\n\theight: 100%;\n\tobject-fit: cover;\n\tborder-radius: 50%;\n\tbackground-color: var(--secondary-color);\n}\n\n.navbar-title {\n\tfont-size: 1.6rem;\n\tfont-weight: 600;\n\tcolor: var(--white);\n\tmargin: 0;\n\ttext-align: right;\n}\n\n.back-button {\n\twidth: 100px;\n\tbackground-color: var(--secondary-color);\n\tcolor: black;\n\tfont-size: 18px;\n}\n\n.back-button:hover {\n\tbackground-color: var(--secondary-hover);\n}\n\n.home-button {\n\tbackground-color: var(--secondary-color);\n\tcolor: black;\n\tfont-size: 18px;\n\tpadding: 8px 16px;\n\ttext-decoration: none;\n\tborder-radius: 5px;\n\tmargin-right: 20px;\n\twhite-space: nowrap;\n}\n\n.home-button:hover {\n\tbackground-color: var(--secondary-hover);\n}\n\n.modal-overlay {\n    top: 120px;\n}\n\n@media (max-width: 768px) {\n\t.profile-border {\n\t\twidth: 60px;\n\t\theight: 60px;\n\t}\n\n\t.menu-bar {\n\t\ttop: 82px;\n\t\twidth: 120px;\n\t}\n\n\t.menu-bar li {\n\t\tfont-size: 12px;\n\t}\n\n\t.navbar-title {\n\t\tfont-size: 23px;\n\t\ttext-align: center;\n\t}\n}\n\n@media (max-width: 480px) {\n\t.profile-border {\n\t\twidth: 55px;\n\t\theight: 55px;\n\t}\n\n\t.menu-bar {\n\t\ttop: 80px;\n\t\twidth: 80px;\n\t}\n\n\t.menu-bar li {\n\t\tfont-size: 10px;\n\t}\n\n\t.navbar-title {\n\t\tfont-size: 20px;\n\t\ttext-align: center;\n\t}\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
